import {
  TTerraceModel,
  TTerraceWidth,
  TTerraceDepth,
  TPoles,
  TGlassOpacity,
  TLedSpots,
  TDitchForm,
  TSupportForm,
  TAttachment,
  TMarqueeType,
  TEngineType,
  TEnginePosition,
  TFabricColor,
  TSidewallRight,
  TSidewallLeft,
  TSidewallFront,
  TLedSpotsSet,
  TGlassDensity,
  TDockTile,
  TDockOpacity,
  TTyp,
  TFacadae,
} from '../../../../utility/type/terraceCover.type'

/**
 * Default values for the terrace cover scene
 * @param castShadow Decides if shadow should be casted or not
 * @param height Height of the terrace cover
 * @param width Width of the terrace cover
 * @param depth Depth of the terrace cover
 * @param windowsTopTotal Total top windows
 * @param windowsFrontTotal Total front windows
 * @param windowsSideTotal Total side windows
 * @param model Model of the terrace cover
 * @param ditchForm The way the front bar closes up
 * @param supportForm The way the support logs close up
 * @param safetyGlass A value that translates safetyGlassDensity into opacity
 * @param safetyGlassDensity The option for DARI safety glass
 * @param dockGlass A value that translates dockTile into opacity
 * @param dockTile The option for CHATA dock tile
 * @param ledSpots The option for led spots
 * @param ledSpotsSet The quantity of led spots (sets)
 * @param attachment Decides whether the terrace cover is attached to the wall
 * @param marquee The type of marquee
 * @param engine The type of engine
 * @param enginePosition The positon of the engine
 * @param fabricColor The color of the marquee
 * @param glassTie The size of the front window tie
 * @param sidewallRight The option for the right glass
 * @param sidewallLeft The option for the left glass
 * @param sidewallFront The option for the front glass
 */

export const scene = {
  castShadow: true,
  height: 300,
  width: 200 as TTerraceWidth,
  depth: 200 as TTerraceDepth,
  windowsTopTotal: 3,
  windowsFrontTotal: 2,
  windowsSideTotal: 2,
  poles: 2 as TPoles,
  model: 'DARI' as TTerraceModel,
  ditchForm: 'Classic (eckig)' as TDitchForm,
  supportForm: 'Classic (eckig)' as TSupportForm,
  safetyGlass: 0.3 as TGlassOpacity,
  safetyGlassDensity: '8 mm klar' as TGlassDensity,
  dockGlass: 0 as TDockOpacity,
  dockTile: '16mm klar' as TDockTile,
  ledSpots: '6er Set mit Funk-Dimmer' as TLedSpots,
  ledSpotsSet: '0 Set' as TLedSpotsSet,
  attachment: 'Wandmontage' as TAttachment,
  typ: 'Normal' as TTyp,
  marquee: '- Ohne Markise -' as TMarqueeType,
  engine: '- Ohne Funk -' as TEngineType,
  enginePosition: 'Links' as TEnginePosition,
  fabricColor: '#e9e0d2' as TFabricColor,
  glassTie: 3.5,
  sidewallRight: '- Ohne Seitenwand rechts -' as TSidewallRight,
  sidewallLeft: '- Ohne Seitenwand links -' as TSidewallLeft,
  sidewallFront: '- Ohne Wand vorn -' as TSidewallFront,
  ego: false,
  night: false,
  facade: 'Raubputz' as TFacadae,
}
